import { createSlice } from '@reduxjs/toolkit';
import { callThunk } from '~/api';
import { HTTP_STATUS } from '~/constants/api';
import * as adminActions from '~/features/admin/adminSlice';
import * as userActions from '~/features/user/userSlice';
import * as apiList from '~/apiTs';

const initialState = null;

/**
 * APIエラーの状態管理Slice。
 * Axiosエラーオブジェクトをそのままセットする。
 * このstateがnullじゃなければ、httpステータスに従ってPageWrapperによってエラー画面が表示される。
 * HACK: apiRequestSliceと統合しても良いかも。
 */
const axiosErrorSlice = createSlice({
  name: 'axiosError',
  initialState,
  reducers: {
    // エラーページに遷移したらstateをnull（初期値）に戻す
    initializeAxiosError: () => {
      return null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(callThunk.rejected, (_, action) => {
      //     // apiじゃない場所でエラーが発生した場合を考慮。status500を挿入してあげる。
      if (action?.payload?.status === undefined) {
        return {
          status: HTTP_STATUS.INTERNAL_SERVER_ERROR,
        };
      }
      return action.payload;
    });

    // adminかuserで401エラーが発生したら初期化
    builder.addCase(adminActions.unauthorizedErrorRaised, () => initialState);
    builder.addCase(userActions.unauthorizedErrorRaised, () => initialState);

    // Create handling for api calls
    const actionTypes = [];
    Object.entries(apiList).forEach(([, func]) => {
      if (func.rejected && !actionTypes.includes(func.rejected.toString())) {
        actionTypes.push(func.rejected.toString());
        builder.addCase(func.rejected, (_, action) => {
          if (action?.payload?.status === undefined) {
            return {
              status: HTTP_STATUS.INTERNAL_SERVER_ERROR,
            };
          }
          return action.payload;
        });
      }
    });
  },
});

// reducerをexportする
export default axiosErrorSlice.reducer;
